import { VatSettingsModel } from "../../vat-setting/models/vat-settings.model";

export class SubscriptionModel {
  public subscriptionID: number;
  public subscriptionHashId: string;
  public subscriptionName: string;
  public description: string;
  public timeInterval: string = '';
  public amount: number;
  public amountDisplay: string;
  public freeKilometer: string;
  public freeMinute: string = '0';
  public sharedVehicleGroupHashId: string = '';
  public contractTypeGroupList: string[] = [];
  public currencySymbol: string;
  public vatPercentage: string;
  public vatSettingDefaultCost: boolean = true;
  public vatIncludedInPrice: boolean = true;
  public isChecked: boolean;
  public paymentInterval: string = '';
  public invoiceInterval: string = '';
  public freeKilometerInterval: string = 'MONTHLY';
  public freeMinuteInterval: string = 'MONTHLY';
  public invoiceMomentDay: number;
  public invoiceMomentDayOfWeek: string = '';
  public defaultContractTypeGroupHashId: string = '';
  public sendInvoiceToDriver: string = "INHERIT";
  public sendInvoiceToOrganization: string = "INHERIT";
  public bookAheadTime: string = "0";
  public bookingHorizon: string = "";
  public totalAvailabilityRestriction: string;
  public isEditable: boolean;
  public isDeletable: boolean;
  public isRestrictionCount: boolean;
  public bearer: number = 1;
  public freeItemCTGHashId:string="";
  public isCurrencySymbolBefore: boolean = true;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupsubscription/models/sharedvehiclegroupsubscription.model.ts